import {useDispatch, useSelector} from "react-redux";
import {
    onOrderLoadDetails,
    onOrdersClearPending, onOrdersClearUpdates,
    onOrdersLoad, onOrdersRemovePending, onOrdersRemoveUpdates,
} from "../../store/Orders/actions";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";

const UpdatesOrders = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch();

    const onOrderClick = (orderId) => {
        dispatch(onOrdersRemoveUpdates(0))
        dispatch(onOrderLoadDetails(orderId))
    }
    const onClearPending = () => dispatch(onOrdersClearUpdates())

    const { orderUpdates } = useSelector(({ orders }) => orders);

    useEffect(() => {
        if (orderUpdates.length > 0) {
            dispatch(onOrdersLoad())
        }
    }, [orderUpdates])


    return (
        <>
            {orderUpdates.length ? (
                <div className="bg-pink-300  max-w-screen-xl mx-auto py-2 sm:px-2 lg:px-6 rounded-md mt-5">
                    <div className="flex items-center justify-between flex-wrap">
                        <div className="w-0 flex-1 flex items-center min-w-0">
                    <span className="flex p-2 rounded-lg">
                        <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </span>

                            <p className="ml-3 font-medium text-sm text-white truncate" >
                                {t('You have {{count}} order status updates', {count:orderUpdates.length})}
                            </p>
                            <p className="ml-3 font-medium text-sm text-white truncate">
                                {/*<a href={`/chain/orders/${pending[0].id}`} target="_blank" onClick={() => onOrderClick(pending[0].id)}>View Order</a>*/}
                                <button className="items-center px-4 py-2 border border-transparent rounded-md font-semibold text-xs uppercase tracking-widest focus:shadow-outline-gray disabled:opacity-25 transition ease-in-out duration-150 ml-2 bg-white text-black hover:bg-gray-100 focus:outline-none focus:border-yellow-500" onClick={() => onOrderClick(orderUpdates[0].id)}>
                                    {t('View order')}
                                </button>
                            </p>
                        </div>

                        <div className="flex-shrink-0 sm:ml-3">
                            <button
                                onClick={onClearPending}
                                type="button"
                                className="-mr-1 flex p-2 rounded-md focus:outline-none sm:-mr-2 transition ease-in-out duration-150"
                                aria-label="Dismiss">
                                <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            ) :null}


            {/*<PendingModal order={order} visible={showOrder} onClose={closeModalOrder} />*/}
        </>
    );
}

export default UpdatesOrders
